let css = require('./controls.css');
let { cut } = require('../../../../../../helpers/utils');
let { onEdit, onCancel, onSave } = require('../../../../../../signals/account/editable-order');

const EDIT_SELECTOR = cut(css.edit);
const SAVE_SELECTOR = cut(css.save);
const CANCEL_SELECTOR = cut(css.cancel);

class Controls {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [EDIT_SELECTOR]: this.onEdit,
                [SAVE_SELECTOR]: this.onSave,
                [CANCEL_SELECTOR]: this.onCancel
            }
        };
    }

    onEdit (e) {
        e.preventDefault();
        this.$context.signal(onEdit);
    }

    onSave (e) {
        e.preventDefault();
        this.$context.signal(onSave);
    }

    onCancel (e) {
        e.preventDefault();
        this.$context.signal(onCancel);
    }
}

module.exports = {
    constructor: Controls
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/editable-order/controls/index.js